import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/components/SpecMapShell.tsx");
